<template>
    <div class="content-full">
        <ui-breadcrumb title="Create an App" :items="['Projects', 'Apps', 'Create']"></ui-breadcrumb>
        <div class="col-auto">
            <div class="row">
                <div class="col-12">
                    <div class="block block-rounded block-fx-shadow">
                        <div class="block-header block-header-default">
                            <div class="block-title">Developer App Details</div>
                        </div>
                        <div class="block-content">
                            <el-form :model="app" :rules="rules" ref="appDetails">
                                <div class="row">
                                    <div class="col-lg-4">
                                        <p class="text-muted">
                                            Creating an app involves first giving your app a name
                                        </p>
                                    </div>
                                    <div class="col-lg-8">
                                        <!-- Form Labels on top - Default Style -->
                                        <div class="mb-5">
                                            <div class="form-group">
                                                <el-form-item label="App Name" prop="name">
                                                    <el-input v-model="app.name">
                                                    </el-input>
                                                </el-form-item>
                                            </div>
                                            <div class="form-group">
                                                <!--<label>-->
                                                <label for="description">Description
                                                    <small class="text-muted">(optional)</small>
                                                </label>
                                                <el-form-item prop="description">
                                                    <el-input type="textarea"
                                                              id="description"
                                                              rows="3"
                                                              v-model="app.description"
                                                              placeholder="Tell us more about your awesome app"
                                                    ></el-input>
                                                </el-form-item>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="form-group">
                                                <el-button icon="fa fa-check" :loading="loading" type="primary" @click="saveApiApp"
                                                        class="btn btn-outline-primary float-right">
                                                    Create App
                                                </el-button>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- END Form Labels on top - Default Style -->
                                </div>
                            </el-form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import App from '../../models/ApiApp';
    import Breadcrumb from '../utils/Breadcrumb';
    import {FormWizard, TabContent} from 'vue-form-wizard';
    import {Utils} from "../../helpers/utils";

    export default {
        components: {
            'ui-breadcrumb': Breadcrumb,
            'form-wizard': FormWizard,
            'tab-content': TabContent
        },
        data() {
            return {
                app: App,
                loading: false,
                rules: {
                    name: 'required|max:191',
                    description: 'max:255'
                }
            }
        },
        mounted() {
            this.loadProducts();
        },

        computed: {
            /*
              Gets the user load status
            */
            appCreatedStatus() {
                return this.$store.getters.getAppCreatedStatus;
            },
            /*
              Fetch the available API products from store
            */
            products() {
                return this.$store.getters.getProducts;
            },
            apiApp() {
                return this.$store.getters.getApp;
            }
        },
        methods: {
            /*
             Get the API products available for registration
           */
            loadProducts() {
                this.$store.dispatch('getApiProducts');
            },
            /*
                Post a new app
            */
            saveApiApp() {
                this.loading = true;
                this.$refs['appDetails'].validate((valid) => {
                    if (valid) {
                        this.$store.dispatch('createNewApp', this.app).then(() => {
                            this.$refs['appDetails'].resetFields();
                            this.$router.push(`/users/profile`);
                        });
                    } else {
                        this.loading = false;
                    }
                });
            }
        }
    }
</script>
<style scoped lang="scss">
    .el-checkbox__label {
        font-weight: 900;
        font-size: 15px;
    }
</style>
